export default "__VITE_ASSET__6682e1e6__"